import { buildClient } from '../utils/url';
var connectorService = {
    baseUrl: {
        TRAVELPERK: 'travelperk',
        CLIMATIQ: 'climatiq',
    },
    travelPerk: {
        MANUAL_IMPORT: '/manual-import',
    },
    climatiq: {
        MANUAL_IMPORT: '/manual-import',
        IMPORT_MAPPING: '/import-mapping',
    },
};
var connectorServiceClient = {
    travelPerk: buildClient(connectorService.baseUrl.TRAVELPERK, connectorService.travelPerk),
    climatiq: buildClient(connectorService.baseUrl.CLIMATIQ, connectorService.climatiq),
};
export { connectorService, connectorServiceClient };
//# sourceMappingURL=connector-service.js.map